export function arrayUniqueByKey(data, key) {
  var undefinedValues = false;
  var resultArr;

  if (data && Array.isArray(data)) {

    var dataMap = data.map(item => {
      if (item !== undefined) {
        return [item[key], item];

      } else {
        undefinedValues = true;
        return undefined;
      }
    });

    if (!undefinedValues) {
      resultArr = [...new Map(dataMap).values()];
    } else {
      resultArr = [];
    }
  } else {
    resultArr = [];
  }

  return resultArr;

  // return data && Array.isArray(data)
  //   ? [...new Map(data.map(item => [item[key], item])).values()]
  //   : [];
}
